import { NgModule } from '@angular/core';

import { SafePipe } from './safe.pipe';
import { HumanDatePipe } from './humanDate.pipe';

@NgModule({
    declarations: [
        SafePipe,
        HumanDatePipe
    ],
    exports     : [
        SafePipe,
        HumanDatePipe
    ]
})

export class FusePipesModule
{

}



// WEBPACK FOOTER //
// ./src/app/core/pipes/pipes.module.ts